import React from 'react';
import { Grommet, ThemeType } from 'grommet';
import { GROMMET_SBOT_V2 } from '@theme/sbot.theme';

interface Props {
  full?: boolean;
  background?: string;
}

const SHDThemeOverride: React.FC<React.PropsWithChildren<Props>> = ({
  background = 'white',
  children,
  full = true,
  ...props
}) => {
  return (
    <Grommet
      background={background}
      cssVars={true}
      full={full}
      options={{
        box: { cssGap: true },
      }}
      theme={GROMMET_SBOT_V2 as ThemeType}
      {...props}
    >
      {children}
    </Grommet>
  );
};

export default SHDThemeOverride;
